import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

export interface ContactFormData {
    FullName: string
    EmailAddress: string
    PhoneNumber?: string | null
    Organization?: string | null
    Message: string
}

export interface ContactResponse {
    data: any
}

export const contactFormAPI = createApi({
    reducerPath: 'contact', //our reducer lives at store.reducer
    tagTypes: ['ContactFormData'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3'), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<ContactResponse, Partial<ContactFormData>>({
            query: (body) => ({
                url: '/Page/contact',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const { useSubmitFormMutation } = contactFormAPI
